/* eslint-disable import/no-extraneous-dependencies, no-underscore-dangle */

import dayjs from 'dayjs'
import i18n from '../../i18n'

export function formatDay(day, locale = i18n.language) {
    return dayjs(day)
        .locale(locale)
        .format('ddd ll')
}

export function formatMonthTitle(date, locale = i18n.language) {
    return dayjs(date)
        .locale(locale)
        .format('MMMM YYYY')
}

export function formatWeekdayShort(day, locale = i18n.language) {
    return dayjs()
        .locale(locale)
        ._locale.weekdaysMin()[day]
}

export function formatWeekdayLong(day, locale = i18n.language) {
    return dayjs()
        .locale(locale)
        ._locale.weekdays()[day]
}

export function getFirstDayOfWeek(locale = i18n.language) {
    const localeData = dayjs.localeData(locale)
    return localeData.firstDayOfWeek()
}

export function getMonths(locale = i18n.language) {
    const months = []
    let i = 0
    while (i < 12) {
        months.push(
            dayjs()
                .locale(locale)
                .month(i)
                .format('MMMM')
        )
        i += 1
    }
    return months
}

export function formatDate(date, format = 'YYYY-MM-DD', locale = i18n.language) {
    return dayjs(date)
        .locale(locale)
        .format(Array.isArray(format) ? format[0] : format)
}

export function parseDate(str, format = 'YYYY-MM-DD', locale = i18n.language) {
    const m = dayjs(str, format, locale, true)
    if (m.isValid()) {
        return m.toDate()
    }
    return undefined
}

export default {
    formatDay,
    formatMonthTitle,
    formatWeekdayShort,
    formatWeekdayLong,
    getFirstDayOfWeek,
    getMonths,
    formatDate,
    parseDate
}



// WEBPACK FOOTER //
// ./components/Datepicker/DayjsUtils.js